module.exports = __webpack_public_path__ + "img/Organization.491e726d.jpg";